
<p-dialog #tokenDialog header="JWT Dialog" [(visible)]="displayTokenDialog" [modal]="true"
  [style]="{width: '600'}" [focusOnShow]="false">
  Need to invoke an API in Postman? Set an Authentication header as follows:
  <div class="row">
    <div class="col-10">
      <textarea disabled wrap style="width: 100%">{{idToken}}</textarea>
    </div>
  </div>
  <div>
    <span>ID Token (Expires: {{idTokenExpiration}}):</span>
    <textarea disabled wrap style="width: 100%; height: 200px">{{parsedIdToken}}</textarea>
  </div>
  <div>
    <span>Refresh Token:</span>
    <textarea disabled wrap style="width: 100%; height: 200px">{{refreshToken}}</textarea>
  </div>
  <p-footer>
    <button i18n id="refreshToken" class="btn btn-primary" (click)="refreshSession()">Refresh</button>
    <button i18n id="idTokenOk" class="btn btn-primary" (click)="displayTokenDialog = false">OK</button>
  </p-footer>
</p-dialog>

